import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalContext } from "../../LocalProvider.js";
import {
  getCartItemsDataAction,
  moveImportProductsToCartItemsDataAction,
  smartGetCartData
} from "../../store/actions/cartItems.actions";
import { removeToWishListDataAction } from "../../store/actions/product.actions.js";
import {
  getWishListData,
  moveCartToCartItemsDataAction,
  clearWishListDataAction
} from "../../store/actions/wishlist.actions";
import {
  getHeaderToken,
  isAuthenticated
} from "../../store/selectors/navItems.selector";
import { totalPage, getPaginatedData, pagePerItems } from "../../utils/pagination";
import {
  getEnv
} from "../../utils/urls";
import LoadingHOC from "../common/loader/LoadingHOC.component";
import {
  CheckoutButton,
  ClearCartButton,
  StyledTableCell,
  useStyles
} from "./Wishlist.styles";
import { selectedLanguage } from "../../store/selectors/language.selector";

export const WishlistContext = createContext();

const WishlistContextProvider = (props) => {
  const isAuth = useSelector(isAuthenticated);
  const token = useSelector(getHeaderToken);
  const selectedLocLanguage = useSelector(selectedLanguage);
  const [page, setPage] = useState(1);
  const { translate } = useContext(LocalContext);
  const classes = useStyles();
  const { setLoading } = props;
  const dispatch = useDispatch();
  const [wishlistDataProvider, setWishlistDataProvider] = useState([]);
  const [clearWishList, setClearWishList] = useState(false);
  const [wishlistArrayPayload, setWishlistArrayPayload] = useState({
    orderType: "ZOR",
    items: [],
  });
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [payload, setPayload] = useState({
    offset: (page - 1) * pagePerItems,
    limit: pagePerItems    
  });
  const [errorMsg, setErrorMsg] = useState("");

  const getAllWishListData = useCallback(() => {
    return dispatch(getWishListData(token, payload)).then((res) => {
      setLoading(false);
      if (res && res.success === false) {
        setErrorMsg(res.msg);
        setWishlistDataProvider([]);
        setClearWishList(true);
        setTotalPageCount(0);
      } else {
        //Get the data from Get wishlist API
        // dispatch(getCartItemsDataAction(token));
        const paginatedData = getPaginatedData(res?.items, pagePerItems, 1);
        setWishlistDataProvider(paginatedData);
        setTotalPageCount(totalPage(res?.totalCount, pagePerItems));
        setErrorMsg("");
      }
    });
  }, [token, isAuth, payload]);

  const handleChangePagination = (event, value) => {
    if (value !== page) {
      setPage(value);
      setPayload({ ...payload, offset: (value - 1) * payload.limit })
    }
  };

  //Wishlist Page Quantity Update Handler
  const updateWishlistItemsInputData = (
    productInfo,
    value,
    isAuth,
    token,
    payload
  ) => {
    if (productInfo.count >= 1) {
      moveImportProductsToCartItemsDataAction(payload, isAuth, token);      
    }
  };

  const addToCartWishlist = () => {
    moveCartToCartItemsData(isAuth, token, wishlistDataProvider);
  };

  //Product Listing Page from Wishlist Page on Add to Cart Button
  const moveCartToCartItemsData = (isAuth, token, rmaDataCollection) => {
    setLoading(true);
    // get product id and update count
    let updateCartPayload = {
      orderType: "ZOR",
      items: rmaDataCollection.map((cartData) => ({
        id: cartData.id,
        quantity:
          cartData.count === 0 || cartData.count === ""
            ? 0
            : parseInt(cartData.count),
        unitType: cartData.unitType.find((type) => type.active === 1)?.key || "", // Optimized retrieval of unitType
      })),
    };

    dispatch(moveCartToCartItemsDataAction(token, updateCartPayload)).then((data) => {
      setLoading(false);
      if (data.success === false) {
        setErrorMsg(data.msg);
      } else {
        setErrorMsg("");
        let productsWithCount = {};
        let defaultCount = 0;
        data.items &&
          data.items.length > 0 &&
          data.items.forEach((cartData) => {
            productsWithCount[cartData.id] = cartData.count;
            defaultCount = parseInt(cartData.count) + parseInt(defaultCount);
          });
        productsWithCount["defaultCount"] = parseInt(defaultCount);
        dispatch(smartGetCartData(false, token));
      }
      return data;
    });
  };

  // Clear WishlistAction Handlder
  const clearWishListData = (token) => {
    setLoading(true);
    dispatch(clearWishListDataAction(token)).then((data) => {
      setLoading(false);
      if (data.success === false) {
        setErrorMsg(data.msg);
      } else {
        setErrorMsg("");
      }
      return data;
    });
  };

  //call orderHistory api to use as cartItemData
  useEffect(() => {
    setLoading(true);
    getAllWishListData();
  }, [payload, selectedLocLanguage]);

  // handle wishlistData and setting WishlistArrayPayload
  useEffect(() => {
    let payloadDataAyy = [];
    wishlistDataProvider &&
      wishlistDataProvider.length > 0 &&
      wishlistDataProvider.map((singleSubOrder) => {
        let payloadData = {
          id: singleSubOrder.id,
          quantity: singleSubOrder.count,
          unitType: singleSubOrder.unitType.find((type) => type.active === 1)?.key || "", // Optimized retrieval of unitType
        };
        payloadDataAyy.push(payloadData);
        return payloadData;
      });
    setWishlistArrayPayload({
      orderType: "ZOR",
      items: payloadDataAyy,
    });
    //
  }, [wishlistDataProvider]);

  const handelRemoveItem = (productInfo) => {
    setLoading(true);
    dispatch(removeToWishListDataAction(productInfo, token)).then(() => {
      setLoading(false);
      let filteredDataProvider = wishlistDataProvider.filter(
        (data) => data.id !== productInfo.id
      );
      setWishlistDataProvider(filteredDataProvider);
      wishlistArrayPayload?.items?.flatMap((singleData, index) => {
        if(singleData.id === productInfo.id) {
          return wishlistArrayPayload.items.splice(index, 1);
        }
      });
      setWishlistArrayPayload(wishlistArrayPayload);
      if(filteredDataProvider?.length === 0) {
        setLoading(true);
        setPage(page === 1 ? page : page - 1);
        setPayload({
          offset: page === 1 ? 0 : ((page - 1) - 1) * pagePerItems,
          limit: pagePerItems
        });
      }
    });
  };

  const handelQtyPlaceholder = (e, productInfo) => {
    if (e === "0") {
      productInfo.count = "";
      let wishData =
        wishlistDataProvider.length > 0 &&
        wishlistDataProvider.map((data, index) => {
          if (data.id === productInfo.id) {
            let ftrDataUpdated = wishlistDataProvider.filter(
              (dataUpdated) => dataUpdated.id === productInfo.id
            );
            ftrDataUpdated.count = productInfo.count;
          }
          return data;
        });
      setWishlistDataProvider(wishData);

      wishlistArrayPayload.items.length > 0 &&
        wishlistArrayPayload.items.map((data, index) => {
          if (data.id === productInfo.id) {
            return (wishlistArrayPayload.items[index].quantity =
              productInfo.count);
          }
          // added to fix return message
          return wishlistArrayPayload;
        });

      setWishlistArrayPayload(wishlistArrayPayload);
    }
  };

  // Product Quantity update event
  const handelRMAQty = (e, productQuantity, productInfo) => {
    // Disabaled the dispatch event in case of blank string and value should be greater than zero
    //max length should be three digit

    if (isNaN(productQuantity)) {
      e.preventDefault();
    }

    if (productQuantity < 9 || productQuantity > 0) {
      // Incase of minimum quantity, we are restricting it to 0
      if (productQuantity === "") {
        productInfo.count = 0;
      }
      //max length should be three digit
      if (productQuantity.length <= 3 && productQuantity != 0) {
        productQuantity = parseInt(productQuantity);
        productInfo.count = productQuantity;
      }
    }

    let wishData =
      wishlistDataProvider.length > 0 &&
      wishlistDataProvider.map((data, index) => {
        if (data.id === productInfo.id) {
          let ftrDataUpdated = wishlistDataProvider.filter(
            (dataUpdated) => dataUpdated.id === productInfo.id
          );
          ftrDataUpdated.count = productInfo.count;
        }
        return data;
      });

    setWishlistDataProvider(wishData);

    wishlistArrayPayload.items.length > 0 &&
      wishlistArrayPayload.items.map((data, index) => {
        if (data.id === productInfo.id) {
          return (wishlistArrayPayload.items[index].quantity =
            productInfo.count);
        }
        // added to fix return message
        return wishlistArrayPayload;
      });

    setWishlistArrayPayload(wishlistArrayPayload);
  };

  const handleUnitType = (event, productId, productInfo) => {
    let updatedRmaData = wishlistDataProvider.map((data) => {
      if (data.id === productId) {
        data.unitType.map((unitKey) => {
          if (unitKey.key === event.target.value) {
            unitKey.active = 1;
          } else {
            unitKey.active = 0;
          }
          // added to fix return message
          return data;
        });
      }
      return data;
    });

    setWishlistDataProvider(updatedRmaData);
    wishlistArrayPayload.items.map((data, index) => {
      if (data.id === productId) {
        return (wishlistArrayPayload.items[index].unitType =
          event.target.value);
      }
      // added to fix return message
      return data;
    });
    setWishlistArrayPayload(wishlistArrayPayload);
    updateWishlistItemsInputData(
      productInfo,
      productInfo.count,
      isAuth,
      token,
      wishlistArrayPayload
    );
  };

  // Clear Wishlist Handler
  const clearWishlistHandler = () => {
    clearWishListData(token);
    setWishlistDataProvider([]);
    setClearWishList(true);
  };

  if (wishlistDataProvider) {
    return (
      <>
        <div className={classes.headerTitleStyle}>
          <h2 className={classes.titleSummary}>{translate("Your Wishlist")}</h2>
          {wishlistDataProvider.length > 0 && (
            <ClearCartButton
              className={classes.clearCart}
              onClick={() => clearWishlistHandler()}
            >
              {translate("Clear Wishlist")}
            </ClearCartButton>
          )}
        </div>
        <WishlistContext.Provider
          value={{
            wishlistDataProvider,
            clearWishList,
            handelRemoveItem,
            handelQtyPlaceholder,
            handelRMAQty,
            handleUnitType,
          }}
        >
          {clearWishList.length === 0 ? (
            !clearWishList ? (
              <p className={classes.textCenter}>
                {translate("Your wishlist is Loading")} ...
              </p>
            ) : (
              <p className={classes.textCenter}>
                {translate("Your wishlist is Empty")}
              </p>
            )
          ) : (
            <>
              <TableContainer
                component={Paper}
                className={classes.tableContainerStyle}
                key={1}
              >
                <Table className={classes.table} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        <div className={classes.productTitle}>
                          {translate("Product")}
                        </div>
                      </StyledTableCell>

                      <StyledTableCell
                        align="center"
                        className={classes.onlyDesktopTableCell}
                      >
                        <div className={classes.productTitle}>
                          {translate("Code")}
                        </div>
                      </StyledTableCell>
                      {getEnv().displayBarCode === "true" && (
                        <StyledTableCell
                          align="center"
                          className={classes.onlyDesktopTableCell}
                        >
                          <div className={classes.productTitle}>
                            {translate("Bar Code")}
                          </div>
                        </StyledTableCell>
                      )}
                      <StyledTableCell
                        align="center"
                        className={classes.columnQtyPrice}
                      >
                        <div className={classes.quantityTitle}>
                          {translate("Quantity")}
                        </div>
                      </StyledTableCell>
                      {getEnv().displayUnitType === "true" && (
                        <StyledTableCell
                          align="center"
                          className={
                            classes.columnQtyPrice +
                            " " +
                            classes.onlyDesktopTableCell
                          }
                        >
                          <div
                            className={
                              classes.costTitle +
                              " " +
                              classes.onlyDesktopTableCell
                            }
                          >
                            {translate("Unit Type")}
                          </div>
                        </StyledTableCell>
                      )}
                      <StyledTableCell
                        align="center"
                        className={classes.columnQtyPrice}
                      >
                        <div className={classes.costTitle}>
                          {translate("Unit Price")}
                        </div>
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={classes.shoppingProductColumn}
                      ></StyledTableCell>
                      <StyledTableCell
                        align="right"
                        className={classes.deleteProductColumn}
                      ></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {props.children}
                </Table>
              </TableContainer>

              <div className={classes.buttonStyle}>
                {wishlistDataProvider.length > 0 && (
                  <>
                    <Pagination
                      className={classes.pagination}
                      size="large"
                      count={totalPageCount}
                      page={page}
                      onChange={handleChangePagination}
                      color="primary"
                      showFirstButton
                      showLastButton
                      boundaryCount={2}
                    />
                  <CheckoutButton onClick={() => addToCartWishlist()}>
                    <strong>{translate("Add to cart").toUpperCase()}</strong>
                  </CheckoutButton>
                  </>
                )}
              </div>
            </>
          )}
        </WishlistContext.Provider>
      </>
    );
  } else {
    return null;
  }
};

export default LoadingHOC(WishlistContextProvider);
